export const weekDays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

export const companySize = [
  {
    label: '1-10',
    value: '1-10',
  },
  {
    label: '11-25',
    value: '11-25',
  },
  {
    label: '26-50',
    value: '26-50',
  },
  {
    label: '50+',
    value: '50+',
  },
];

export const usTimeZoneOptions = [
  {
    label: 'US/Alaska',
    value: 'US/Alaska',
  },
  {
    label: 'US/Aleutian',
    value: 'US/Aleutian',
  },
  {
    label: 'US/Arizona',
    value: 'US/Arizona',
  },
  {
    label: 'US/Central',
    value: 'US/Central',
  },
  {
    label: 'US/East-Indiana',
    value: 'US/East-Indiana',
  },
  {
    label: 'US/Eastern',
    value: 'US/Eastern',
  },
  {
    label: 'US/Hawaii',
    value: 'US/Hawaii',
  },
  {
    label: 'US/Indiana-Starke',
    value: 'US/Indiana-Starke',
  },
  {
    label: 'US/Michigan',
    value: 'US/Michigan',
  },
  {
    label: 'US/Mountain',
    value: 'US/Mountain',
  },
  {
    label: 'US/Pacific',
    value: 'US/Pacific',
  },
  {
    label: 'US/Samoa',
    value: 'US/Samoa',
  },
];
export const canadaTimeZoneOptions = [
  {
    label: 'Canada/Atlantic',
    value: 'Canada/Atlantic',
  },
  {
    label: 'Canada/Central',
    value: 'Canada/Central',
  },
  {
    label: 'Canada/Eastern',
    value: 'Canada/Eastern',
  },
  {
    label: 'Canada/Mountain',
    value: 'Canada/Mountain',
  },
  {
    label: 'Canada/Newfoundland',
    value: 'Canada/Newfoundland',
  },
  {
    label: 'Canada/Pacific',
    value: 'Canada/Pacific',
  },
  {
    label: 'Canada/Saskatchewan',
    value: 'Canada/Saskatchewan',
  },
  {
    label: 'Canada/Yukon',
    value: 'Canada/Yukon',
  },
];
export const australiaTimeZoneOptions = [
  {
    label: 'Australia/ACT',
    value: 'Australia/ACT',
  },
  {
    label: 'Australia/Adelaide',
    value: 'Australia/Adelaide',
  },
  {
    label: 'Australia/Brisbane',
    value: 'Australia/Brisbane',
  },
  {
    label: 'Australia/Broken_Hill',
    value: 'Australia/Broken_Hill',
  },
  {
    label: 'Australia/Canberra',
    value: 'Australia/Canberra',
  },
  {
    label: 'Australia/Currie',
    value: 'Australia/Currie',
  },
  {
    label: 'Australia/Darwin',
    value: 'Australia/Darwin',
  },
  {
    label: 'Australia/Eucla',
    value: 'Australia/Eucla',
  },
  {
    label: 'Australia/Hobart',
    value: 'Australia/Hobart',
  },
  {
    label: 'Australia/LHI',
    value: 'Australia/LHI',
  },
  {
    label: 'Australia/Lindeman',
    value: 'Australia/Lindeman',
  },
  {
    label: 'Australia/Lord_Howe',
    value: 'Australia/Lord_Howe',
  },
  {
    label: 'Australia/Melbourne',
    value: 'Australia/Melbourne',
  },
  {
    label: 'Australia/NSW',
    value: 'Australia/NSW',
  },
  {
    label: 'Australia/North',
    value: 'Australia/North',
  },
  {
    label: 'Australia/Perth',
    value: 'Australia/Perth',
  },
  {
    label: 'Australia/Queensland',
    value: 'Australia/Queensland',
  },
  {
    label: 'Australia/South',
    value: 'Australia/South',
  },
  {
    label: 'Australia/Sydney',
    value: 'Australia/Sydney',
  },
  {
    label: 'Australia/Tasmania',
    value: 'Australia/Tasmania',
  },
  {
    label: 'Australia/Victoria',
    value: 'Australia/Victoria',
  },
  {
    label: 'Australia/West',
    value: 'Australia/West',
  },
  {
    label: 'Australia/Yancowinna',
    value: 'Australia/Yancowinna',
  },
];
export const newZealandTimeZoneOptions = [
  {
    label: 'Pacific/Auckland',
    value: 'Pacific/Auckland',
  },
  {
    label: 'Pacific/Chatham',
    value: 'Pacific/Chatham',
  },
];
// UK only - used for country-specific onboarding
export const ukTimeZoneOptions = [
  { label: 'Europe/London', value: 'Europe/London' },
];

// All Europe timezones - used for profile timezone selection
export const europeTimeZoneOptions = [
  { label: 'Europe/Amsterdam', value: 'Europe/Amsterdam' },
  { label: 'Europe/Athens', value: 'Europe/Athens' },
  { label: 'Europe/Berlin', value: 'Europe/Berlin' },
  { label: 'Europe/Brussels', value: 'Europe/Brussels' },
  { label: 'Europe/Bucharest', value: 'Europe/Bucharest' },
  { label: 'Europe/Budapest', value: 'Europe/Budapest' },
  { label: 'Europe/Copenhagen', value: 'Europe/Copenhagen' },
  { label: 'Europe/Dublin', value: 'Europe/Dublin' },
  { label: 'Europe/Helsinki', value: 'Europe/Helsinki' },
  { label: 'Europe/Istanbul', value: 'Europe/Istanbul' },
  { label: 'Europe/Kyiv', value: 'Europe/Kyiv' },
  { label: 'Europe/Lisbon', value: 'Europe/Lisbon' },
  { label: 'Europe/London', value: 'Europe/London' },
  { label: 'Europe/Madrid', value: 'Europe/Madrid' },
  { label: 'Europe/Moscow', value: 'Europe/Moscow' },
  { label: 'Europe/Oslo', value: 'Europe/Oslo' },
  { label: 'Europe/Paris', value: 'Europe/Paris' },
  { label: 'Europe/Prague', value: 'Europe/Prague' },
  { label: 'Europe/Rome', value: 'Europe/Rome' },
  { label: 'Europe/Stockholm', value: 'Europe/Stockholm' },
  { label: 'Europe/Vienna', value: 'Europe/Vienna' },
  { label: 'Europe/Warsaw', value: 'Europe/Warsaw' },
  { label: 'Europe/Zurich', value: 'Europe/Zurich' },
];

export const asiaTimeZoneOptions = [
  { label: 'Asia/Almaty', value: 'Asia/Almaty' },
  { label: 'Asia/Amman', value: 'Asia/Amman' },
  { label: 'Asia/Baghdad', value: 'Asia/Baghdad' },
  { label: 'Asia/Baku', value: 'Asia/Baku' },
  { label: 'Asia/Bangkok', value: 'Asia/Bangkok' },
  { label: 'Asia/Beirut', value: 'Asia/Beirut' },
  { label: 'Asia/Colombo', value: 'Asia/Colombo' },
  { label: 'Asia/Damascus', value: 'Asia/Damascus' },
  { label: 'Asia/Dhaka', value: 'Asia/Dhaka' },
  { label: 'Asia/Dubai', value: 'Asia/Dubai' },
  { label: 'Asia/Ho_Chi_Minh', value: 'Asia/Ho_Chi_Minh' },
  { label: 'Asia/Hong_Kong', value: 'Asia/Hong_Kong' },
  { label: 'Asia/Irkutsk', value: 'Asia/Irkutsk' },
  { label: 'Asia/Jakarta', value: 'Asia/Jakarta' },
  { label: 'Asia/Jerusalem', value: 'Asia/Jerusalem' },
  { label: 'Asia/Kabul', value: 'Asia/Kabul' },
  { label: 'Asia/Karachi', value: 'Asia/Karachi' },
  { label: 'Asia/Kathmandu', value: 'Asia/Kathmandu' },
  { label: 'Asia/Kolkata', value: 'Asia/Kolkata' },
  { label: 'Asia/Krasnoyarsk', value: 'Asia/Krasnoyarsk' },
  { label: 'Asia/Kuala_Lumpur', value: 'Asia/Kuala_Lumpur' },
  { label: 'Asia/Kuwait', value: 'Asia/Kuwait' },
  { label: 'Asia/Magadan', value: 'Asia/Magadan' },
  { label: 'Asia/Manila', value: 'Asia/Manila' },
  { label: 'Asia/Muscat', value: 'Asia/Muscat' },
  { label: 'Asia/Novosibirsk', value: 'Asia/Novosibirsk' },
  { label: 'Asia/Riyadh', value: 'Asia/Riyadh' },
  { label: 'Asia/Seoul', value: 'Asia/Seoul' },
  { label: 'Asia/Shanghai', value: 'Asia/Shanghai' },
  { label: 'Asia/Singapore', value: 'Asia/Singapore' },
  { label: 'Asia/Taipei', value: 'Asia/Taipei' },
  { label: 'Asia/Tashkent', value: 'Asia/Tashkent' },
  { label: 'Asia/Tehran', value: 'Asia/Tehran' },
  { label: 'Asia/Tokyo', value: 'Asia/Tokyo' },
  { label: 'Asia/Vladivostok', value: 'Asia/Vladivostok' },
  { label: 'Asia/Yakutsk', value: 'Asia/Yakutsk' },
  { label: 'Asia/Yekaterinburg', value: 'Asia/Yekaterinburg' },
  { label: 'Asia/Yerevan', value: 'Asia/Yerevan' },
];

export const roles = [
  {
    label: 'Admin',
    value: 'Admin',
  },
  {
    label: 'Technician',
    value: 'Technician',
  },
];
